// Task 43 (owner: "it should show the product name, asin, shipping method"): humanize SP-API
// inbound shipping modes for the Shipment Runs page and the Shipment Planner's Previous Runs
// panel. The backend may join multiple distinct modes with " + " when a placement mixes them.
const SHIPPING_MODE_LABELS = {
    GROUND_SMALL_PARCEL: 'UPS Ground',
    FREIGHT_LTL: 'LTL freight',
    FREIGHT_FTL: 'FTL freight',
    FREIGHT_FTL_PALLET: 'FTL pallet freight',
    OCEAN_LESS_THAN_CONTAINER_LOAD: 'LCL ocean',
    OCEAN_FULL_CONTAINER_LOAD: 'FCL ocean',
    AIR_SMALL_PARCEL: 'Air parcel',
    AIR_SMALL_PARCEL_EXPRESS: 'Air parcel express',
};

export function humanizeShippingMode(mode) {
    if (!mode) return null;
    return String(mode)
        .split(' + ')
        .map(part => SHIPPING_MODE_LABELS[part]
            || part.replace(/_/g, ' ').toLowerCase().replace(/\b\w/g, c => c.toUpperCase()))
        .join(' + ');
}
